import { apiSlice } from '../../app/api/apiSlice'

export const reportsApi = apiSlice.injectEndpoints({
  endpoints:  (builder) => ({
    getOrderReport: builder.query ({
      query: (type) => `v2/reports/orders/${type}`
    })
  })
})

export const {
  useGetOrderReportQuery
} = reportsApi